<template>
    <div class="wrapper home-wrapper" :style="{'z-index': transitionStart ? 1111 : 'auto'}" ref="homeWrapper">
    <!-- <div class="wrapper home-wrapper" ref="homeWrapper"> -->
        <div class="ll" ref="homeBox">

            <div class="h-head" ref="hHead">
                <div class="flexBox">
                    <div class="u-tree-menu flexBox" @click="$router.push({name: 'treeMenu'})">
                        <img src="/static/images/navs/treeMenu.png">
                        <span>知识目录</span>
                    </div>
                    <p class="u-search flexItem flexBox" @click="$router.push({name: 'searchKnowledge'})">
                        <i class="icon icon-search"></i>
                        <span class="p-text">你有什么想了解的？</span>
                    </p>
                    <!-- <div class="u-seek-help flexBox" @click="actionSeekHelp('Ask')">
                        <img src="/static/images/navs/seekhelp.png">
                        <span>求助</span>
                    </div> -->
                </div>

                <section class="self-service-box mt-70">
                    <div class="service-items flexBox">
                        <div class="service-item flexBox" v-for="(service, index) in serviceDefaultObj.List" @click="actionEmit(service)">
                            <img :src="service.Icon" class="service-icon">
                            <span class="service-name" v-text="service.Name"></span>
                        </div>
                    </div>

                    <div class="service-down-icon">
                        <img class="arrow-down" src="/static/images/icon/arrow_down.svg" @click="slideDown">
                    </div>
                </section>
            </div>

            <div class="h-head h-head-fixed" ref="hHeadFix" :class="{headVisible: transitionStart}" @touchstart="touchStart" @touchmove="touchMove">
                <div class="h-head-fixed-inner">
                    <fade-transition :duration="666" @afterEnter="afterEnter" @beforeLeave="beforeLeave" @afterLeave="afterLeave">
                        <div v-show="expandShow">
                            <h2 class="service-head">自助服务</h2>
                            <h3 class="service-group-name service-group-name-spec" v-text="serviceDefaultObj.Category"></h3>
                        </div>
                    </fade-transition>

                    <section class="self-service-box">
                        <div class="service-items service-items-default flexBox">
                            <div class="service-item flexBox" :class="{'service-wins-item': isWinsClient}" v-for="(service, index) in serviceDefaultObj.List" @click="actionEmit(service)">
                                <img :src="service.Icon" class="service-icon">
                                <span class="service-name" v-text="service.Name"></span>
                            </div>
                        </div>

                        <collapse-transition :duration="666">
                            <section class="service-group" v-show="expandShow">
                                <template v-for="(serviceGroup, index) in serviceExpandList">
                                    <h3 class="service-group-name" v-text="serviceGroup.Category"></h3>
                                    <div class="service-items service-transition-items flexBox">
                                        <div class="service-item flexBox" :class="{'service-wins-item': isWinsClient}" v-for="service in serviceGroup.List" @click="actionEmit(service)">
                                            <img :src="service.Icon" class="service-icon">
                                            <span class="service-name" v-text="service.Name"></span>
                                        </div>
                                    </div>
                                </template>
                            </section>
                        </collapse-transition>
                    </section>
                </div>
            </div>
                
            
            <fade-transition :duration="666">
                <div class="dialog-mask" v-show="expandShow" @click="slideUp" @touchmove.prevent></div> 
            </fade-transition>

            <fade-transition v-if="iconCtrl" @beforeLeave="iconBeforeLeave">
                <div class="service-up-icon" ref="upIcon" @click="slideUp" v-show="showUpIcon">
                    <img class="arrow-up" src="/static/images/icon/arrow_up.svg">
                </div>
            </fade-transition>

            <!-- h-fixed-tab-wrap 滚动到 知识推荐tab区 不见时显示知识推荐导航 -->
            <div class="h-fixed-tab-wrap">
                <div class="h-fixed-tab" ref="hfixedtab" id="fScroll">
                    <div class="f-box" ref="fbox">
                    <span class="f-tab-bullet" v-for="(ftab, index) in topicList" :class="{'active': swiperIndex == index}" @click="clickTab(index)">
                        <span v-text="ftab.Name" :class="{'updated': !ftab.IsRead}"></span>
                    </span>
                    </div>
                </div>
                <span class="tab-search-icon icon icon-search flexBox" @click="$router.push({name: 'searchKnowledge'})"></span>
            </div>

            <div class="h-main-content">
                <h3 class="h-plaintext">知识推荐</h3>
                <swiper :options="topicSwiperOption" class="topic-swiper" ref="topicTitleSwiper">
                    <swiper-slide v-for="(ctab, index) in topicList" class="topic-swiper-slide" :class="{'topic-swiper-slide-active':index === swiperIndex}" :key="index">
                        <div class="topic-item" @click="ClickTopicSwiper(index)">
                            <img :src="ctab.ImgUrl">
                            <p class="topic-title flexBox">
                                <span v-text="ctab.Name" :class="{'blank': ctab.Name == '', 'updated': !ctab.IsRead}"></span>
                            </p>
                        </div>
                    </swiper-slide>
                </swiper>
                <swiper :options="swiperOption" class="h-lists-box" ref="topicListSwiper">
                    <swiper-slide v-for="(tabqlist, index) in topicList" class="lists" :key="index" :sign="'lists-' + index">
                        <result-list2 :lists="topicItemList[index]" :LogId="LogId" :firstTab="index === 0 ? true : false"></result-list2>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .wrapper {
        .h-head-fixed {
            position: fixed;
            z-index: 9999;
            top: 0;
            // left: 220px;
            background: rgb(255, 255, 254);
            // background: oldlace;
            display: none;
            // max-height: calc(100vh - 1.6rem - 0.853rem);
            max-height: calc(100vh - 1.6rem);
            overflow: auto;
            padding-top: j(30);
            padding-bottom: j(60);
            border-bottom-left-radius: j(40);
            border-bottom-right-radius: j(40);
        }
        .h-head-fixed-inner {
            overflow: auto;
            overflow-x: hidden;
        }
        .headVisible {
            display: unset;
        }
    }
    .service-group {
        .service-transition-items:last-child {
            margin-bottom: 0;
        }
    }
    .service-group + .service-group {
        margin-top: j(60);
    }
    .arrow-up-test {
        position: fixed;
        z-index: 9999;
        bottom: 45px;
        cursor: pointer;
    }
    
    .self-service-box {
        position: relative;
        font-size: 0;
    }
    .mt-70 {
        margin-top: j(70);
    }
    .dialog-mask {
        position: fixed;
        z-index: 1111;
        top: 0; bottom: 0;
        left: 0; right: 0;
        background: rgba(0, 0, 0, .3);
    }

    .service-head {
        font-weight: 600;
        font-size: j(48);
        height: j(66);
        line-height: j(66);
        color: #363c54;
    }
    .service-group-name {
        height: j(42);
        line-height: j(42);
        font-weight: 400;
        font-size: j(30);
        color: #9b9da9;
        margin-bottom: j(35);
    }
    .service-group-name-spec {
        margin-top: j(28);
    }
    .service-items {
        justify-content: flex-start;
        .service-item:nth-child(n+5) {
            margin-top: j(40);
        }
        .service-item:nth-child(4n) {
            margin-right: 0;
        }
        // justify-content: space-between;
    }
    .service-items-default {
        margin-bottom: j(60);
    }
    .service-transition-items {
        margin-bottom: j(60);
    }

    .service-items-transition-cd {
        margin-bottom: j(60);
    }
    .service-item-cd {
        display: inline-block;
        width: j(100);
        margin-right: j(82);
        text-align: center;
        .service-icon {
            width: j(48);
            height: j(48);
        }
        .service-name {
            display: block;
            margin-top: j(20);
            font-size: j(24);
            color: rgba(54, 60, 84, 1);
            white-space: nowrap;
        }
    }
    .service-item-cd:nth-child(n+5) {
        margin-top: j(40);
    }
    .service-item-cd:nth-child(4n) {
        margin-right: 0;
    }
    
    .service-down-icon {
        text-align: center;
        .arrow-down {
            width: j(24);
            padding: j(18) j(80);
        }
    }
    .service-up-icon {
        position: fixed;
        z-index: 9999;
        // top: 0;
        font-size: 0;
        left: j(50); right: j(50);
        // left: 0; right: 0;
        // background: oldlace;
        // opacity: .5;
        background: #fff;
        text-align: center;
        height: j(64);
        line-height: j(64);
        // border-bottom-left-radius: j(40);
        // border-bottom-right-radius: j(40);
        .arrow-up {
            width: j(24);
            height: 100%;
            // padding: j(20) j(80);
        }
    }

    .pt-sets {
        padding-top: j(20);
    }
    
    .service-transition-items {
        flex-wrap: wrap;
    }
    
    .service-item {
        width: j(101);
        margin-right: j(82);
        flex-direction: column;
        &.service-wins-item {
            // windows微信客户端有滚动条 占据了宽度
            width: j(92);
        }
        .service-icon {
            width: j(48);
            height: j(48);
        }
        .service-name {
            margin-top: j(20);
            font-size: j(24);
            color: rgba(54, 60, 84, 1);
            white-space: nowrap;
        }
    }
</style>

<script>
    import { HOME, COMMON } from '../api'
    import 'swiper/dist/css/swiper.css'
    import commonMixin from '@/utils/commonMixin'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import dsBridge from '../utils/jsbridge'
    import { CollapseTransition, FadeTransition } from 'vue2-transitions'

    let fontSize22 = document.getElementsByTagName('html')[0].style.fontSize
    let htmlFontSize22 = Number(fontSize22.split('px')[0])
    let spaceBetween = 0.6 * 2 * htmlFontSize22
    export default {
        name: "Home",
        mixins: [ commonMixin ],
        components: {
            swiper, swiperSlide, CollapseTransition, FadeTransition
        },
        data() {
            return {
                serviceList: [],
                serviceDefaultObj: {},
                serviceExpandList: [],
                LogId: '',
                topicList: [],  // 专题目录列表
                topicItemList: [],  // 专题下的知识列表
                scr_t: 0,
                pageSize: 15,
                pageIndexArr: [],  // 存储多个tab接口请求页码
                pageCountArr: [],
                prevAjaxEnd: true,  // 上一次接口请求完成
                treeLists: [],
                treeList: [],  //结构化知识查询  一级目录
                isNavigate: false,  //首页引导页面
                nodeId: '',
                swiperIndex: 0,
                swiperOption: {
                    touchAngle: 20,
                    autoHeight: true
                },
                topicSwiperOption: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 15,
                    slidesOffsetBefore: 25,
                    slidesOffsetAfter: 25,
                    normalizeSlideIndex: false,
                    preventClicks: false,
                    observer: true,//修改swiper自己或子元素时，自动初始化swiper
                },
                fixedTabOpacity: 0,
                showFixedTabWrap: false,
                qrcodeImg: false,
                expandShow: false,  // 折叠起来的服务是否展示
                transitionStart: false,
                showUpIcon: false,
                startPageY: 0,
                iconCtrl: true
            }
        },
        computed: {
            topicSwiper() {
                return this.$refs.topicTitleSwiper.swiper
            },
            topicListSwiper() {
                return this.$refs.topicListSwiper.swiper
            },
            barActive() {
                return this.$route.name
            },
            authType() {
                return localStorage.AUTH_TYPE
            },
            isWinsClient() {
                return /Windows/ig.test(navigator.userAgent)
            }
        },
        mounted() {

            this.getServiceConfig()

            //获取专题列表以及专题列表下面的知识点、FAQ
            this.GetRecommendTab()

            this.$nextTick(() => {
                // this.cScroll = new iScroll("cScroll", {
                //     vScroll: false,
                //     fadeScrollbar: false
                // })

                this.fScroll = new iScroll('fScroll', {
                    vScroll: false,
                    fadeScrollbar: false
                })
            })

            // 滚动监听
            this.$refs.homeWrapper.addEventListener('scroll', this.scrollHandler, false)
        },
        methods: {
            touchStart(event) {
                this.startPageY = event.changedTouches[0].pageY
            },
            touchMove(event) {
                // 下滑
                if (event.changedTouches[0].pageY > this.startPageY) {
                    // 触顶
                    if (this.$refs['hHeadFix'].scrollTop === 0) {
                        event.preventDefault()
                    }
                }

                // 上滑
                if (event.changedTouches[0].pageY < this.startPageY) {
                    // 触底
                    if (this.$refs['hHeadFix'].scrollTop + this.$refs['hHeadFix'].clientHeight >= this.$refs['hHeadFix'].scrollHeight) {
                        event.preventDefault()
                    }
                }
            },
            getServiceConfig() {
                HOME.GetServiceConfig().then( (res) => {
                    this.serviceList = res.Data.List || []
                    this.serviceDefaultObj = this.serviceList.filter( (list, index) => {
                        return index === 0
                    })[0]
                    this.serviceDefaultObj.List = this.serviceDefaultObj.List.filter( (item, index) => {
                        return index < 4
                    })
                    this.serviceExpandList = this.serviceList.filter( (list, index) => {
                        return index !== 0
                    })
                })
            },
            actionEmit(service) {

                COMMON.DOP_ViewData({
                    logName: 'NIOHOME_25_SelfServiceHits',
                    data: {
                        ADAccount: localStorage.ADAccount,
                        RequestTime: this.$formatTime(Date.now()),
                        ServiceName: service.Name
                    }
                }).then((res) => {})

                if (service.OpenType === 1) {  // 跳转外链
                    location.href = service.Url
                }
                if (service.OpenType === 2) {  // 内部路由
                    this.$router.push(service.Url)
                }
                if (service.OpenType === 3) {  // 触发内部行为
                    if (service.Url === 'garbage') {  // 垃圾分类
                        this.$store.commit('GARBAGE_QRCODE', true)
                    }
                    if (service.Url === 'call2500') {  // 2500
                        if (this.authType === 'WECHAT') {
                            location.href = 'tel:4008212500'
                        } else if (this.authType === 'TOOLKIT') {
                            this.callPhone()
                        }
                    }
                    if (service.Url === 'serviceRequest') {  // 服务请求
                        this.actionSeekHelp('Ask')
                    }
                }
            },
            slideDown() {
                document.body.style.overflow = "hidden";
                document.getElementsByClassName("ll")[0].style.overflow = "hidden";
                document.getElementsByClassName("ll")[0].style.height = 'calc(100vh - 1.306rem)'

                this.expandShow = true
                this.transitionStart = true
                this.iconCtrl = true
            },
            slideUp() {
                this.$refs['hHead'].scrollTop = 0
                this.expandShow = false
            },
            afterEnter() {
                // let Iphonex = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && screen.height == 812 && screen.width == 375
                let timer = setTimeout( () => {
                    this.showUpIcon = true
                    // 254 => 255 手动触发浏览器重绘 fix部分小米机型圆角花边问题
                    this.$refs['hHeadFix'].style.backgroundColor = 'rgb(255, 255, 255)'
                    let hHeight = this.$refs['hHeadFix'].offsetHeight - 0.853 * (localStorage.FontSize || 0)
                    this.$refs['upIcon'].style.top = hHeight + 'px'
                    clearTimeout(timer)
                }, 333)
            },
            beforeLeave() {
                this.showUpIcon = false
            },
            afterLeave() {
                this.$nextTick( () => {
                    this.transitionStart = false
                    document.getElementsByClassName("ll")[0].style.overflow = "unset";
                    document.getElementsByClassName("ll")[0].style.height = "unset";
                })
            },
            iconBeforeLeave() {
                this.iconCtrl = false
            },
            //获取专题列表
            GetRecommendTab() {  // 获取专题目录列表
                HOME.GetTabTopic().then((res) => {
                    this.topicList = res.Data.List
                    this.topicItemList = new Array(this.topicList.length)
                    this.setCMSTopicRead(0)
                    // 获取第一个展示的tab list
                    this.getTabList(0)
                    setTimeout(() => {
                        this.ListenTopicListSwiper()
                        // this.cScroll.refresh()
                        this.fScroll.refresh()
                    }, 300)

                    // 初始化
                    // this.pageIndexArr = new Array(this.topicList.length).fill(1)
                    // this.pageCountArr = new Array(this.topicList.length)
                })
            },
            // 获取专题目录下的知识列表
            getTabList(tabIndex) {
                //---------埋点-------------
                try {
                    if (this.topicList[tabIndex].Name !== '每日更新') {
                        COMMON.AddTopicViewData({
                            TopicId: this.topicList[tabIndex].Id,
                            TopicName: this.topicList[tabIndex].Name,
                        }).then((res) => {
                            this.LogId = res.Data.LogId
                        })
                    }
                } catch (e) {}

                // 已经有数据，不再请求接口...
                if (this.topicItemList[tabIndex]) return

                HOME.GetCMSTopicContent({
                    id: this.topicList[tabIndex].Id,
                    Keywords: this.topicList[tabIndex].Name,
                    PageIndex: 1,
                    PageSize: this.pageSize
                }).then((res) => {
                    let KFList = (res.Data && res.Data.List) || [];
                    let count = res.Data.TotalCount;
                    let noMore = count / this.pageSize <= 1;
                    // 如果总页数少于等于1，则"没有更多了"；
                    let listItem = {
                        noMore: noMore,
                        pageIndex: 1,
                        itemList: KFList
                    }
                    this.topicItemList.splice(tabIndex, 1, listItem)
                })
            },
            ClickTopicSwiper(index) {
                this.swiperIndex = index
            },
            // 专题列表swiper  change事件
            ListenTopicListSwiper() {
                const that = this;
                this.topicListSwiper.on('slideChange', function () {
                    that.swiperIndex = this.activeIndex
                    // tab定位
                    // that.cPosition()
                    that.fPosition()

                    // 获取对应index tab 问题list
                    that.getTabList(this.realIndex)
                    that.setCMSTopicRead(that.swiperIndex)

                })
            },
            clickTab(index) {
                this.prevAjaxEnd = true
                this.topicSwiper.slideTo(index)
                this.topicListSwiper.slideTo(index)
                this.setCMSTopicRead(index)
            },
            setCMSTopicRead(index) {  // 设置被点击的专题目录为已读
                // 已经是已读状态，不再调用接口
                if (this.topicList[index].IsRead) return;

                this.topicList[index].IsRead = true;
                // 修改服务端状态
                HOME.SetTopicRead({
                    PrimaryId: this.topicList[index].Id,
                    Type: 1
                })
            },
            scrollHandler() {
                if (this.$route.name !== 'home') return  // home页面才监听

                this.scr_t = this.$refs.homeWrapper.scrollTop
                let win_h = this.$refs.homeWrapper.offsetHeight
                let header_h = document.getElementsByClassName('h-head')[0].offsetHeight
                let complex_tab_h = document.getElementsByClassName('topic-swiper')[0].clientHeight + document.getElementsByClassName('h-plaintext')[0].offsetHeight
                let fixed_tab = document.getElementsByClassName('h-fixed-tab-wrap')[0]
                let fixed_tab_h = document.getElementsByClassName('h-fixed-tab-wrap')[0].offsetHeight
                let dh = this.$refs.homeBox.offsetHeight

                let dif = this.scr_t + 50 - complex_tab_h - header_h
                let rate = 80
                if (dif < -rate) {
                    fixed_tab.style.opacity = 0
                    fixed_tab.style.pointerEvents = 'none'
                } else if (dif >= -rate && dif <= 0) {
                    fixed_tab.style.opacity = (dif + rate) / rate
                    fixed_tab.style.pointerEvents = 'auto'
                } else if (dif > 0) {
                    fixed_tab.style.opacity = 1
                }
                // 控制首页加载
                if (this.scr_t + win_h >= dh) {
                    this.loadMore()
                }
            },
            loadMore() {

                // 如果没有更多，停止加载
                if (this.topicItemList[this.swiperIndex].noMore) return

                // 节流
                if (!this.prevAjaxEnd) return
                this.prevAjaxEnd = false


                let topicId = this.topicList[this.swiperIndex].Id
                let topicName = this.topicList[this.swiperIndex].Name

                this.$store.commit('SET_LOADING_POSITION', 'bottom')
                HOME.GetCMSTopicContent({
                    id: topicId,
                    Keywords: topicName,
                    PageIndex: ++this.topicItemList[this.swiperIndex].pageIndex,
                    PageSize: this.pageSize
                }).then((res) => {

                    let KFList = (res.Data && res.Data.List) || [];
                    let count = res.Data.TotalCount;
                    let noMore = count / this.pageSize <= this.topicItemList[this.swiperIndex].pageIndex;
                    // 如果总页数少于等于1，则"没有更多了"；
                    let listItem = {
                        noMore: noMore,
                        pageIndex: this.topicItemList[this.swiperIndex].pageIndex,
                        itemList: this.topicItemList[this.swiperIndex].itemList.concat(KFList)
                    }
                    this.topicItemList.splice(this.swiperIndex, 1, listItem)

                    this.prevAjaxEnd = true
                    this.$store.commit('SET_LOADING_POSITION', 'middle')
                }).catch(() => {
                    this.prevAjaxEnd = true
                    this.$store.commit('SET_LOADING_POSITION', 'middle')
                })
            },
            cPosition() {  // complex tab 定位

                var fontSize = document.getElementsByTagName('html')[0].style.fontSize
                var htmlFontSize = Number(fontSize.split('px')[0])
                var win_w = window.innerWidth || document.documentElement.clientWeight

                var distance = (win_w - 2.1333 * htmlFontSize) / 2 - 0.6667 * htmlFontSize
                var extraDistance = this.swiperIndex * (2.1333 * htmlFontSize + 0.4 * htmlFontSize)

                if (this.swiperIndex == 0 || this.swiperIndex == 1) {  // 头两个
                    // this.cScroll.scrollTo(0, 0, 500)
                    return
                }
                if (this.topicList.length - 1 - this.swiperIndex <= 1) {  // 后两个
                    var dd = win_w - 2.1333 * htmlFontSize - 0.6667 * htmlFontSize - (this.topicList.length - 1) * (2.1333 * htmlFontSize + 0.4 * htmlFontSize)
                    // this.cScroll.scrollTo(dd - 0.6667 * htmlFontSize, 0, 500)
                    return
                }

                // this.cScroll.scrollTo(distance - extraDistance, 0, 500)
            },
            fPosition() {  // fixed tab 定位

                var fontSize = document.getElementsByTagName('html')[0].style.fontSize
                var htmlFontSize = Number(fontSize.split('px')[0])
                var win_w = window.innerWidth || document.documentElement.clientWeight

                var lDistance = this.lDistance(this.swiperIndex)
                var rDistance = this.rDistance(this.swiperIndex)
                var containerW = this.$refs.hfixedtab.offsetWidth
                var swiperTabW = this.$refs.fbox.getElementsByClassName('f-tab-bullet')[this.swiperIndex].offsetWidth
                var halfDistance = (containerW - swiperTabW) / 2

                if (lDistance < halfDistance) {  // 左边宽度不足以滑到中间
                    this.fScroll.scrollTo(0, 0, 500)
                    return
                }
                if (lDistance >= halfDistance && rDistance >= halfDistance) {
                    var dd = halfDistance - this.lDistance(this.swiperIndex)
                    this.fScroll.scrollTo(dd, 0, 500)
                    return
                }

                if (lDistance >= halfDistance && rDistance < halfDistance) {  // 右边宽度不足以滑到中间
                    var dd = containerW - this.$refs.fbox.getElementsByClassName('f-tab-bullet')[0].offsetWidth - this.rDistance(0)
                    this.fScroll.scrollTo(dd, 0, 500)
                    return
                }
            },
            lDistance(goalIndex) {  // 获取目标tab左边的总距离

                let lGapWidth = 0, lElemWidth = 0
                var fontSize = document.getElementsByTagName('html')[0].style.fontSize
                var htmlFontSize = Number(fontSize.split('px')[0])
                var oFTabBullet = this.$refs.fbox.getElementsByClassName('f-tab-bullet')
                for (let i = 0; i < goalIndex; i++) {
                    lGapWidth += 0.6667 * htmlFontSize
                    lElemWidth += oFTabBullet[i].offsetWidth
                }

                return lGapWidth + lElemWidth
            },
            rDistance(goalIndex) {

                let rGapWidth = 0, rElemWidth = 0, loopLength = this.topicList.length
                var fontSize = document.getElementsByTagName('html')[0].style.fontSize
                var htmlFontSize = Number(fontSize.split('px')[0])
                var oFTabBullet = this.$refs.fbox.getElementsByClassName('f-tab-bullet')
                for (let i = goalIndex + 1; i < loopLength; i++) {
                    rGapWidth += 0.6667 * htmlFontSize
                    rElemWidth += oFTabBullet[i].offsetWidth
                }

                return rGapWidth + rElemWidth
            },
            callPhone() {
                if (dsBridge.call("toolkit.getTokenSyn")) {
                    dsBridge.call("common.dialSyn", "toolkit://dial?phone=4008212500")
                }
            }
        },
        watch: {
            swiperIndex(value) {
                this.topicSwiper.slideTo(value)
                this.topicListSwiper.slideTo(value)
            }
        },
        activated() {
            // fixed 返回页面时的白屏问题
            this.$refs.homeWrapper.scrollTop = this.scr_t
        },
        destroyed() {
            this.$refs.homeWrapper.removeEventListener('scroll', this.scrollHandler)
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrapper {
        // fixed ios can't cover the fixed navbar
        position: relative;
        // z-index: 1110;
        height: 100%;
        // background: #00bebe;
        overflow: auto;
        padding: 0 0 j(98);
        font-size: j(30);
        color: #363C54;
        box-sizing: border-box;
        -webkit-overflow-scrolling: touch;
    }

    .h-head {
        padding-top: j(50);
        padding-left: j(50);
        padding-right: j(50);
        // border-bottom: j(20) solid #FAFAFC;
        width: 100%;
        position: static;
        box-sizing: border-box;
        .u-search {
            background: rgba(247, 247, 248, 1);
            width: 100%;
            height: j(80);
            border-radius: j(40);

            .icon-search {
                font-size: j(40);
                margin: 0 j(20);

                &:before {
                    color: #cdced4;
                }
            }

            .p-text {
                font-size: j(32);
                font-weight: 700;
                color: #cdced4;
                line-height: j(48);
            }
        }
        .u-tree-menu {
            margin-right: j(40);
            img {
                width: j(34);
            }
            span {
                margin-left: j(10);
                font-size: j(28);
                color: #363c54;
            }
        }
        .u-seek-help {
            margin-left: j(40);
            img {
                width: j(50);
            }
            span {
                margin-left: j(6);
                font-size: j(32);
                color: #696d7f;
            }
        }
        .menu-swiper {
            margin: j(80) 0 j(60);
            width: 100%;
            height: j(108);
            .menu-swiper-item {
                color: #363C54;
                width: j(96);
                position: relative;
                overflow: visible;
                justify-content: center;
                .navbar{
                    flex-direction: column;
                }
                .navbar-name {
                    font-size: j(24);
                    font-weight: 400;
                    color: rgba(54, 60, 84, 1);
                    text-align: center;
                    white-space: nowrap;
                }
                .menu-svg-icon {
                    width: j(48);
                    height: j(48);
                    margin-bottom: j(20);
                }
            }
            .edit-password {
                width: j(48);
                height: j(48);
                margin-bottom: j(20);
            }
        }
    }

    .garbage-qrcode {
        position: fixed;
        top: 0; bottom: 0;left: 0; right: 0;
        background-color: rgba(0, 0, 0, 1);
        z-index: 1110;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        & > div {
            width: j(600);
            height: j(860);
            background-color: #fff;
            border-radius: j(20);
            overflow: hidden;
            padding-top: j(100);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            flex-direction: column;
            img {
                height: j(450);
                width: j(450);
                margin-bottom: j(100);
            }
            h5 {
                font-size:j(36);
                color:rgb(54, 60, 84);
                margin-bottom: j(20);
            }
        }
        i {
            margin-top: j(60);
            height: j(80); width: j(80);
            background: url("/static/images/icon/close-circle.png") no-repeat;
            background-size: contain;
        }
    }

    .h-main-content {
        z-index: 1;
        border-top: j(20) solid #FAFAFC;
        overflow: hidden;
        .h-plaintext {
            padding: j(70) j(50) j(50);
            box-sizing: border-box;
            font-size: j(38);
            font-weight: 700;
            color: #363c54;
        }
        .topic-swiper {
            position: relative;
            z-index: 3;
            height: j(200);
            font-size: 0;
            background: #ffffff;
            white-space: nowrap;
            overflow: visible !important;
            // fixed p40 pro机型下偶现(频率比较高)的底部黑条
            // border-color: transparent border-width: 0 不生效
            // 不是border造成的原因 具体原因未知
            &:after {
                position: absolute;
                content: '';
                left: 0; right: 0; bottom: 0;
                height: 1px;
                background: #fff;
            }
            .topic-swiper-slide {
                width: j(160) !important;
                height: j(200);
                .topic-item {
                    height: 100%;
                    width: j(160) !important;
                    border: 1px solid #f5f5f5;
                    border-radius: j(4);
                    flex-direction: column;
                    transition: box-shadow .5s linear;
                    img {
                        width: 100%;
                        height: j(130);
                        object-fit: cover;
                        background-color: #f1f2f3;
                    }
                    .topic-title {
                        width: 100%;
                        height: j(70);
                        text-align: center;
                        justify-content: center;
                        span {
                            position: relative;
                            display: inline-block;
                            max-width: 90%;
                            padding: 0 j(10);
                            font-size: j(24);
                            font-weight: bold;
                            text-align: center;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            box-sizing: border-box;
                            &.blank {
                                background: #fafafa;
                                width: 66%;
                            }
                            &.updated:after {
                                content: '';
                                position: absolute;
                                top: 0;
                                right: 0;
                                width: 4px;
                                height: 4px;
                                background: #ef7575;
                                border-radius: 50%;
                            }
                        }
                    }
                }
            }
            .topic-swiper-slide.topic-swiper-slide-active {
                .topic-item {
                    color: #00bebe;
                    border: none;
                    box-shadow: 0 j(10) j(40) 0 rgba(0, 0, 0, .15);
                }
            }
        }

        .h-lists-box {
            position: relative;
            top: 0;
            z-index: 2;
            margin-top: j(20);
            min-height: j(1824);
            font-size: 0;
            transition: all .5s;
            overflow: hidden;
            //  background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
            .h-list {
                font-size: j(28);
                color: #363c54;
                padding: j(34) 0;
                position: relative;
                overflow: hidden;

                &:after {
                    @include thin-bb(#f0f1f2);
                }
            }
        }
    }

    .h-fixed-tab-wrap {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: j(112);
        background-color: #fff;
        z-index: 99;
        padding-left: j(50);
        padding-right: j(120);
        box-sizing: border-box;
        overflow: hidden;
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, .08);
        pointer-events: none;
        opacity: 0;
        &.border {
            border-bottom: 1px solid rgba(0, 0, 0, .08);
        }
        .h-fixed-tab {
            position: relative;
            height: j(112);
            line-height: j(112);
            white-space: nowrap;
            .f-box {
                height: 100%;
                .f-tab-bullet {
                    font-weight: bold;
                    font-size: j(28);
                    display: inline-block;
                    height: 100%;
                    img {
                        display: none;
                    }
                    .updated {
                        position: relative;
                        &:after {
                            content: '';
                            position: absolute;
                            top: 1px;
                            right: j(-10);
                            width: 4px;
                            height: 4px;
                            background: #ef7575;
                            border-radius: 50%;
                        }
                    }
                }

                .f-tab-bullet.active {
                    color: #00bebe;
                    position: relative;
                    &:after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        width: j(36);
                        height: j(3);
                        margin-left: j(-18);
                        background: #00bebe;
                    }
                }
                .f-tab-bullet + .f-tab-bullet {
                    margin-left: j(50);
                }
            }

            .f-box + div {
                display: none;
            }
        }

        .tab-search-icon {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            font-size: j(36);
            width: j(104);
            height: 100%;
            background-color: #fff;
            align-items: center;
            justify-content: center;
            box-shadow: 0 0 15px 0 rgba(0, 0, 0, .08);
        }
    }
</style>
<style lang="scss" type="text/scss">
    .c-box + div {
        display: none !important;
    }
    .f-box + div {
        display: none;
    }
    .menu-swiper-bar {
        width: 100%;
        height: j(35);
        bottom: j(20);
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .menu-swiper-span {
            width: j(24) !important;
            height: j(4) !important;
            display: block !important;
            outline: none !important;
            background: #CDCED4;
            margin: j(36) 0 0;
            &+.menu-swiper-span{
                margin-left: j(18);
            }
        }
        .menu-swiper-active {
            background: #696D7F;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/home.vue